import { render, staticRenderFns } from "./HmTransferShopGoods.vue?vue&type=template&id=36aae1da&scoped=true&"
import script from "./HmTransferShopGoods.vue?vue&type=script&lang=js&"
export * from "./HmTransferShopGoods.vue?vue&type=script&lang=js&"
import style0 from "./HmTransferShopGoods.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HmTransferShopGoods.vue?vue&type=style&index=1&id=36aae1da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aae1da",
  null
  
)

component.options.__file = "HmTransferShopGoods.vue"
export default component.exports